import {Select} from 'antd';
import {beneficialOwnerOptions} from './kycHubUtils';
import styles from './kycHub.module.scss';

/** Picks which declared beneficial owner a file belongs to. */
export const BeneficialOwnerSelect = ({id, owners, value, onChange}) => (
  <Select
    id={id}
    className={styles.fullWidth}
    placeholder="Choose the owner"
    value={value}
    onChange={onChange}
    options={beneficialOwnerOptions(owners)}
    notFoundContent="No beneficial owners are declared on this account."
  />
);
